import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M10.713 3.687C9.804 3.243 8.872 3 8 3 5.75 3 3.095 4.62 1.493 7.13a1.615 1.615 0 0 0 0 1.74 9.919 9.919 0 0 0 1.873 2.164l1.869-1.869a3 3 0 0 1 3.93-3.93l1.548-1.548Z M6.824 7.576c.125-.35.403-.627.752-.752l-.752.752ZM2.753 13.06a.5.5 0 0 0 .785.607l1.488-1.487c.99.528 2.019.82 2.974.82 2.25 0 4.905-1.62 6.507-4.13a1.616 1.616 0 0 0 0-1.74 9.91 9.91 0 0 0-2.088-2.344l1.726-1.725a.5.5 0 0 0-.606-.785L2.753 13.06Zm7.884-6.491a3 3 0 0 1-4.069 4.069l1.388-1.389L8 9.25a1.25 1.25 0 0 0 1.25-1.294l1.387-1.387Z';
const draw24px =
  'M6.88,14l.58-.58C7.3,13.59,7.1,13.79,6.88,14Zm.58-.58.26-.26Zm6.92-6.92.67-.67Zm8.35,5.32a.43.43,0,0,0,0-.05c-.23-1-2.08-3.21-4.65-4.8l2.45-2.45a.75.75,0,1,0-1.06-1.06L10,13,8.42,14.52,5.93,17,3.48,19.46a.75.75,0,0,0,0,1.06.75.75,0,0,0,1.06,0L7.3,17.76a10.91,10.91,0,0,0,4.55,1.16h.3c5.32-.08,10.28-5.05,10.58-6.76a.65.65,0,0,0,0-.32ZM12,16.38a4.37,4.37,0,0,1-2.52-.8L11,14a2.22,2.22,0,0,0,1,.22A2.25,2.25,0,0,0,14.24,12,2.22,2.22,0,0,0,14,11l1.55-1.55A4.27,4.27,0,0,1,16.38,12,4.39,4.39,0,0,1,12,16.38ZM15.24,5.65l-.19.2-.67.67-.4.4-.87.86A4.13,4.13,0,0,0,12,7.63,4.38,4.38,0,0,0,7.62,12a4.18,4.18,0,0,0,.14,1.07v0l0,.06-.26.26c-.16.15-.36.35-.58.58L5.64,15.26l-.92.92c-2-1.47-3.3-3.16-3.45-4a1,1,0,0,1,0-.16.88.88,0,0,1,0-.16C1.58,10.12,6.63,5.07,12,5.07A9.66,9.66,0,0,1,15.24,5.65Z';
const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const EyeSlashFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'eyeSlashFilled')) as IconWithRender;

EyeSlashFilledIcon.displayName = 'EyeSlashFilledIcon';
EyeSlashFilledIcon.propTypes = Icon.propTypes;
EyeSlashFilledIcon.renderIcon = (props) => <EyeSlashFilledIcon {...props} />;
export default EyeSlashFilledIcon;
